import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { ProfileService } from '../../profile/profile.service';

@Component({
  selector: 'app-creditamount',
  templateUrl: './creditamount.component.html',
  styleUrls: ['./creditamount.component.css']
})
export class CreditamountComponent implements OnInit {

  form = new FormGroup({
    amount:new FormControl('', [Validators.required, Validators.min(1)]),
    payment_type:new FormControl('3'),
    customerid:new FormControl(''),
    description:new FormControl('',[Validators.required])
  });

  submitted:boolean = false;
  subimitted:Boolean=false;
  isloader:Boolean=false;
  public button_name:any='Add amount';
  isdisable:Boolean=false;

  constructor(public dialogRef: MatDialogRef<CreditamountComponent>,private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) private data: any,private snackBar : MatSnackBar,protected data1: ProfileService, ) { }

  ngOnInit() {
    this.formPatch(this.data.data.id)
  }

  onSubmit() {

    if(this.form.invalid){
        this.subimitted=true;
    }else{
      this.isloader=true;
      this.isdisable=true;
      this.button_name='Loading ...';
      console.log("form value ::",this.form.value);
       this.creditamolunt(this.form.value);
    }
  }

  creditamolunt(data){
    this.data1.usercredit(data).subscribe((res:any)=>{
      if(!res.err){
        this.isdisable=false;
        this.isloader=false;
        this.button_name='Add amount';
        this.openSnackBar(res.message,'clear');
        this.closeDialog();
      }
    }, err => {
      this.isdisable=false;
      this.isloader=false;
      this.button_name='Add amount';
      this.openSnackBar('Something went wrong','clear');
      console.error("err::", err);
      this.closeDialog();
    })

  }

  closeDialog(){
    this.dialogRef.close();
  }

  formPatch(customerid){
    console.log("customerid ::",customerid);
    this.form.patchValue({
      customerid:customerid
    })
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }


}
